package com.klantenstop.web.data.models.dto.requests.address

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InsertAddress(
    @SerialName("street_name")
    val streetName: String,
    @SerialName("street_number")
    val streetNumber: String,
    @SerialName("zip_code")
    val zipCode: String,
    val city: String,
    val country: String,
    val latitude: Double? = null,
    val longitude: Double? = null
) {
    val isValid
        get() = streetName.isNotBlank() && streetNumber.isNotBlank() && zipCode.isNotBlank() && city.isNotBlank() && country.isNotBlank()
}
